import { ItineraryService } from './../itinerary.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Itinerary, Day, PointOfInterest } from './../itineray.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-day-pois',
  templateUrl: './itinerary-day-pois.component.html',
  styleUrls: ['./itinerary-day-pois.component.css']
})
export class ItineraryDayPoisComponent implements OnInit {

  itinerary: Itinerary;

  pois: PointOfInterest[];

  dayId: number;

  expanded: boolean[];

  constructor(private snackBar: MatSnackBar, private route: ActivatedRoute, public itineraryService: ItineraryService) { }

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.route.parent.params.subscribe(params => {
      this.dayId = parseInt(params["dayId"]) - 1;
      this.pois = this.itinerary.days[this.dayId].pois;
      this.syncExpanded();
    });
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.pois.forEach(() => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removePoi($event, poi) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questo luogo?")) {
      const idx = this.pois.indexOf(poi);
      this.pois.splice(idx, 1);
      this.snackBar
        .open("Logo eliminato", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.pois.splice(idx, 0, poi);
          this.snackBar.open(
            "Il luogo che avevi eliminato è stato inserito nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addPoi() {
    this.pois.push({
      title: "",
      image: null,
      description: "",
      link: { longUrl: null, shortUrl: null },
      place: null
    });
    this.syncExpanded(true);
  }

  getPois() {
    return this.pois.filter(((poi) => !poi.generated));
  }

}
